import "@/App.css";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Programs } from "@/components/site/Programs";
import { Mission } from "@/components/site/Mission";
import { Press } from "@/components/site/Press";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useLenis();

  return (
    <div className="App bg-white antialiased">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Programs />
        <Mission />
        <Press />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
